<template>
  <div class="page-con">
    <div class="search-box" style="margin-bottom: 10px;">
      <span class="invoice-span">
        <label>纳税人名称:</label>
        <Select
          clearable
          v-model="clientName"
          style="width: 300px"
          filterable
          :remote-method="
            file =>
              remoteMethod(
                file,
                'clientNameOptions',
                'api/order/',
                'twoReport/getReplaceTaxpayerList'
              )
          "
          :default-label="[]"
          :loading="loading"
          :max-tag-count="1"
          :max-tag-placeholder="maxTagPlaceholder"
          @on-set-default-options="
            file => setDefaultOptions(file, 'clientNameOptions')
          "
          placeholder="请选择"
        >
          <Option
            v-for="option in clientNameOptions"
            :value="option"
            :key="option"
            >{{ option }}</Option
          >
        </Select>
      </span>
      <span class="invoice-span">
        <label>所属税务机关:</label>
        <Select
          v-model="taxIdList"
          multiple
          placeholder="选择税务机关"
          :max-tag-count="1"
          :max-tag-placeholder="maxTagPlaceholder"
        >
          <Option
            v-for="(item, index) in taxList"
            :value="item.id"
            :key="index"
            >{{ item.taxComp }}</Option
          >
        </Select>
      </span>
      <span class="invoice-span">
        <label>日期:</label>
        <vxe-input
          class="formInput"
          type="date"
          v-model="time"
          clearable
          placeholder="请选择"
        ></vxe-input>
      </span>

      <Button
        type="primary"
        icon="ios-search"
        @click="search"
        style="margin-left: 10px"
        >查询
      </Button>

      <Button
        type="primary"
        icon="ios-add"
        v-if="isHavePermission('payment2:invoiceReplace:add')"
        style="margin-left: 10px"
        @click="gotoAdd"
        >创建
      </Button>

      <Button
        icon="md-download"
        @click="download"
        style="margin-left: 10px"
        v-if="isHavePermission('payment2:invoiceReplace:download')"
        >导出
      </Button>
      <Button
        icon="md-download"
        @click="downloadAppendix"
        style="margin-left: 10px"
        v-if="isHavePermission('payment2:invoiceReplace:downloadAppendix')"
        >附件导出
      </Button>
    </div>

    <div class="list-box common-shadow">
      <vxe-table
        ref="xTable"
        stripe
        class="table-style"
        align="center"
        highlight-hover-row
        border="none"
        :loading="loading"
        show-footer
        :data="invoiceListData"
        :footer-method="footerMethod"
        @checkbox-all="selectAllEvent"
        @checkbox-change="selectChangeEvent"
      >
        <vxe-table-column
          type="checkbox"
          align="center"
          width="50"
        ></vxe-table-column>
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.index }}</span>
            <Dropdown
              trigger="click"
              style="margin-left: 20px"
              transfer
              v-if="
                isHavePermission('payment2:invoiceReplace:edit') ||
                  isHavePermission('payment2:invoiceReplace:remove')
              "
            >
              <icon
                type="text"
                custom="iconfont icon-gengduo"
                size="12px"
              ></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div
                  style="display: flex; flex-direction: column"
                  v-if="isHavePermission('payment2:invoiceReplace:edit')"
                >
                  <Button class="button-gengduo" @click="gotoEdit(row)"
                    >编辑
                  </Button>
                </div>
                <div
                  style="display: flex; flex-direction: column"
                  v-if="isHavePermission('payment2:invoiceReplace:remove')"
                >
                  <Button class="button-gengduo" @click="gotoRemove(row)"
                    >删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <!--        序号，纳税人名称，纳税人证件号码，日期，税款所属日期，增值税，地方教育附加，教育费附加，城市维护建设税，个人所得税，印花税，其它，纳税总额，完税证明-->
        <vxe-table-column
          field="replaceTaxpayer"
          title="纳税人名称"
          width="150"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column
          field="repalceTaxNum"
          width="200"
          title="纳税人证件号码"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column
          field="taxComp"
          width="150"
          title="所属税务机关"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column field="addTime" title="日期" width="150" show-overflow>
          <template slot-scope="{ row }">
            {{ row.addTime | timeFormatDate }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="addTime"
          title="税款所属日期"
          show-overflow
          width="200"
        >
          <template slot-scope="{ row }">
            <span>
              {{ row.belongBeginTime | timeFormatDate }}
              {{ row.belongBeginTime && row.belongEndTime ? "到" : "" }}
              {{ row.belongEndTime | timeFormatDate }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="addTax"
          title="增值税"
          show-overflow
          width="150"
        ></vxe-table-column>
        <vxe-table-column
          field="localEduAdd"
          title="地方教育附加"
          width="150"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column
          field="eduSurcharge"
          width="150"
          title="教育费附加"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column
          field="constructionTax"
          title="城市维护建设税"
          width="150"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column
          field="individualTax"
          title="个人所得税"
          width="150"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column
          field="stampTax"
          title="印花税"
          width="150"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column
          field="ortherTax"
          title="其它"
          width="150"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column
          field="totalTax"
          title="纳税总额"
          width="150"
          show-overflow
        ></vxe-table-column>
        <vxe-table-column field="fileList" title="完税证明"  width="150" show-overflow>
          <template v-slot="{ row }">
            <upload-detail
              :arrList="row.fileList"
              :maxlength="1"
            ></upload-detail>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :current-page.sync="page.currentPage"
        :page-size.sync="page.pageSize"
        :total="page.totalResult"
        @page-change="change"
      ></vxe-pager>
    </div>

    <AddInvoiceReplace
      ref="addInvoiceReplace"
      @success="getList"
    ></AddInvoiceReplace>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { numberToCurrency } from "@/filters/type";
import {
  getBlob,
  postBlob,
  hideLoading,
  isEmpty,
  isNotEmpty,
  saveBlob,
  showError,
  showLoading,
  showSuccess
} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";
import moment from "moment";
import AddInvoiceReplace from "@/components/payment2/AddInvoiceReplace";
import { apiGet, apiPost } from "@/utils/api";
import UploadDetail from "@/components/common/UploadDetail";

export default {
  mixins: [getAuthOrization],
  components: { AddInvoiceReplace, UploadDetail },
  data() {
    return {
      loading: false,
      clientName: null,
      time: null,
      invoiceListData: [],
      isDesc: null,
      orderBy: null,
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      countRtnVo: {
        allAmount: null,
        thisYearAmount: null,
        lastYearAmount: null,
        initAmount: null
      },
      param: {},
      clientNameOptions: [],
      taxList: [],
      taxIdList: [],
      records: []
    };
  },
  mounted() {
    this.$bus.$on("代开纳税记录", () => {
      this.time = null;
      this.clientName = null;
      this.getList();
    });
    this.getList();
    this.getTaxList();
    this.getListData(
      "",
      "clientNameOptions",
      "api/order/",
      "twoReport/getReplaceTaxpayerList"
    );
  },
  methods: {
    selectChangeEvent({ checked, row }) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({ checked, records }) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    async downloadAppendix() {
      let idList = [];
      if (isNotEmpty(this.records)) {
        this.records.forEach(i => {
          idList.push(i.id);
        });
      } else {
        this.$XModal.alert({
          message: "请至少勾选一项",
          status: "error"
        });
        return;
      }
      let params = {};
      params.ids = idList;

      showLoading();
      let res = postBlob("/api/tax/twoOrders/downReplaceTaxFile", params);
      hideLoading();
      await saveBlob("附件导出", res.data);
    },
    async getTaxList() {
      let res = await $api.tax.post("getTaxList", {});
      if (res.status === 1) {
        this.taxList = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error"
        });
      }
    },
    gotoAdd() {
      this.$refs.addInvoiceReplace.show();
    },
    gotoEdit(row) {
      this.$refs.addInvoiceReplace.show(true, row);
    },
    async gotoRemove(row) {
      let confirmRes = await this.$XModal.confirm(
        "删除后不可恢复",
        "是否删除？"
      );
      if (confirmRes == "confirm") {
        showLoading();
        let res = await $api.twoReport.post("removeInvoiceReplace", {
          id: row.id
        });
        hideLoading();
        this.loading = false;
        if (res.status === 1) {
          showSuccess("操作成功");
          this.getList();
        } else {
          showError(res.message);
        }
      }
    },
    change(val) {
      this.page.currentPage = val.currentPage;
      this.page.pageSize = val.pageSize;
      this.getList();
    },
    search() {
      this.records = [];
      this.page.currentPage = 1;
      this.getList();
    },
    async getList() {
      this.loading = true;
      let param = {
        orderBy: this.orderBy,
        isDesc: this.isDesc,
        page: this.page.currentPage,
        rows: this.page.pageSize
      };
      if (isNotEmpty(this.clientName)) {
        param.replaceTaxpayer = this.clientName;
      }
      if (isNotEmpty(this.time)) {
        param.addTimeBegin = moment(this.time).valueOf(); // 开始时间
        param.addTimeEnd = moment(this.time).valueOf() + 86399999; // 结束时间
      }
      if (this.taxIdList.length > 0) {
        param.taxIds = this.taxIdList;
      }
      this.param = param;
      let res = await $api.twoReport.post("countInvoiceReplace", param);
      this.loading = false;
      if (res.status === 1) {
        res.data.rows.forEach(item => {
          item.index =
            (this.page.currentPage - 1) * 10 + 1 + res.data.rows.indexOf(item);
        });
        this.invoiceListData = res.data.rows;
        this.invoiceListData.map((i) => {
          this.records.map((j) => {
            if (i.id === j.id) {
              this.$refs.xTable.setCheckboxRow(i, true);
            }
          });
        });
        this.page.totalResult = res.data.total;
        this.countRtnVo = isEmpty(res.data.countRtnVo)
          ? {}
          : res.data.countRtnVo;
      }
    },
    footerMethod({ columns, data }) {
      // 底部合计
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "全部合计";
          }
          if (["addTax"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.addTax);
          }
          if (["constructionTax"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.constructionTax);
          }
          if (["eduSurcharge"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.eduSurcharge);
          }
          if (["individualTax"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.individualTax);
          }
          if (["localEduAdd"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.localEduAdd);
          }
          if (["stampTax"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.stampTax);
          }
          if (["totalTax"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.totalTax);
          }
          if (["ortherTax"].includes(column.property)) {
            return numberToCurrency(this.countRtnVo.ortherTax);
          }
          return null;
        })
      ];
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path) {
      if (query !== "") {
        this.getListData(query, options, url, path);
      } else {
        this[options] = [];
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    async getListData(query, options, url, path) {
      let params = {};
      if (!isEmpty(query)) {
        params.word = query;
      }
      let res = await apiGet(url, path, params);
      if (res.status === 1) {
        this[options] = res.data.replaceTaxpayerList;
      }
    },
    async download() {
      showLoading();
      let res = getBlob(
        "/api/order/twoReport/exportInvoiceReplace",
        this.param
      );
      hideLoading();
      await saveBlob(".zip", res.data);
    }
  }
};
</script>


<style scoped>
.search-box .invoice-span {
  display: inline-block;
  padding-right: 10px;
  margin-bottom: 10px;
}

.finance-span-time .line-icon {
  display: inline-block;
  width: 52px;
  text-align: center;
}

.search-box label {
  display: inline-block;
  padding: 0 5px;
  color: #999;
}

.search-box .vxe-input--inner,
.search-box .ivu-input,
.search-box .ivu-select-selection {
  border-radius: 0;
  border: 1px solid #dcdee2;
  height: 34px;
  box-sizing: border-box;
}

.search-box .ivu-select {
  width: 320px;
  height: 34px;
  overflow: hidden;
}

.search-box .ivu-select-multiple .ivu-tag,
.search-box .ivu-select-input {
  display: inline-block;
  float: left;
}

.search-box .ivu-select-default.ivu-select-multiple .ivu-select-selection {
  max-height: 32px;
  border-radius: 0;
}

.search-box .ivu-select-prefix i {
  vertical-align: middle;
  position: absolute;
  right: 8px;
  top: 8px;
}
</style>